import styled from 'styled-components'

export const ModalBody = styled.div`
display: flex;
flex-direction: column;

.VariantColor:nth-child(2n+1){
    background: var(--c2);
}

.VariantColor{
    padding: .5rem 1rem .5rem 1rem;
}

a:first-child{
    margin-right:1rem;
}

overflow: auto;
max-height:60vh;
::-webkit-scrollbar {
  width: .5rem;
}
/* heigth */
::-webkit-scrollbar {
  height: 0.375rem;
}
/* Track */
::-webkit-scrollbar-track {
  background: #f1f1f1;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 0.625rem;
}
/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
`

export const ImgVariant = styled.img<{borderColor: string}>`
 height: 3.125rem;
 width: 3.125rem;
 border-radius: 1.563rem;
 border: 0.125rem solid var(--${props => props.borderColor});
 margin-right: 1rem;
`

export const ModalFooter = styled.div`
display: flex;
justify-content: end;
margin-top: 1rem;
padding-right: 1rem;
padding-bottom: 1rem;
`
